import { Component, OnInit } from '@angular/core';
import { MessageChannelService, BnLoadingService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { LimiteContratacao } from 'src/app/model/limite-agente-financeiro.model';

import { TarefasInadimplenciaService } from './tarefas.inadimplencia.service';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';

@Component({
    selector: 'app-tarefa-inadimplencia',
    templateUrl: './tarefas-inadimplencia.component.html',
    styleUrls: ['./tarefas-inadimplencia.component.scss'],
    standalone: false
})
export class TarefasInadimplenciaComponent implements OnInit {


  public cpfOuCnpjBeneficiario: string;
  public cnpjAgenteFinanceiro: string;

  constructor(
    private loadingService: BnLoadingService,
    private service: TarefasInadimplenciaService,
    private messageService: MessageChannelService) {
  }

  ngOnInit() {
  }

  verificarInadimplenciaBeneficiario() {
    this.loadingService.bloqueiaTela();

    this.service.verificarInadimplenciaBeneficiario(this.cpfOuCnpjBeneficiario)
      .subscribe(estaInadimplente => {

        this.messageService.addMessage({
          title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: 'Beneficiário está inadimplente? ' + (estaInadimplente ? 'Sim' : 'Não')
        });

        this.loadingService.liberaTela();
      }, (error) => {
        console.log(error);
        this.loadingService.liberaTela();
      });
  }

  verificarInadimplenciaBeneficiarioFgi() {
    this.loadingService.bloqueiaTela();

    this.service.verificarInadimplenciaBeneficiarioNoFgiTradicional(this.cpfOuCnpjBeneficiario)
      .subscribe(estaInadimplente => {

        this.messageService.addMessage({
          title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: 'Beneficiário está inadimplente no FGI Tradicional (sistema legado)? ' + (estaInadimplente ? 'Sim' : 'Não')
        });

        this.loadingService.liberaTela();
      }, (error) => {
        console.log(error);
        this.loadingService.liberaTela();
      });
  }

  verificarInadimplenciaAgenteFinanceiro() {
    this.loadingService.bloqueiaTela();

    this.service.verificarInadimplenciaAgenteFinanceiro(this.cnpjAgenteFinanceiro)
      .subscribe(inadimplenciaAgente => {

        let msg = 'Agente tem inadimplencia técnica: ' + (inadimplenciaAgente.inadimplenciaTecnica ? 'Sim' : 'Não') + '\n' + 
                  'Agente tem inadimplencia financeira: ' + (inadimplenciaAgente.inadimplenciaFinanceira ? 'Sim' : 'Não');

        this.messageService.addMessage({
          title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: msg
        });

        this.loadingService.liberaTela();
      }, (error) => {
        console.log(error);
        this.loadingService.liberaTela();
      });
    }
      
      verificarInadimplenciaFinanceiraAgenteFinanceiroNoFgi() {
        this.loadingService.bloqueiaTela();
    
        this.service.verificarInadimplenciaAgenteFinanceiroNoFgiTradicional(this.cnpjAgenteFinanceiro)
          .subscribe(inadimplenciaAgente => {
    
            this.messageService.addMessage({
              title: 'Sucesso',
              type: 'CRUD_OPERATION',
              level: messageLevel.SUCCESS,
              message: 'Agente tem inadimplencia financeira no FGI Tradicional: ' + (inadimplenciaAgente.inadimplenciaFinanceira ? 'Sim' : 'Não')
            });
    
            this.loadingService.liberaTela();
          }, (error) => {
            console.log(error);
            this.loadingService.liberaTela();
          });
      }

  

}